import RegionsTable from './RegionsTable';

export default RegionsTable;
